/**
 * Insert text at a caret range inside a string (textarea selection model).
 * Pads a trailing space only for phrase-like inserts (ends with punctuation or length>2)
 * when the following character is alphanumeric — never for single special characters.
 */
export function insertAtCaret(
  text: string,
  insert: string,
  selectionStart: number,
  selectionEnd: number
): { next: string; caret: number } {
  const start = Math.max(0, Math.min(selectionStart, text.length));
  const end = Math.max(start, Math.min(selectionEnd, text.length));
  const chunk = insert.length > 0 ? insert : '';
  const after = text.slice(end);
  const phraseLike = chunk.length > 2 || /[,.;:!?…]$/.test(chunk);
  const needsSpace =
    phraseLike &&
    chunk.length > 0 &&
    !/\s$/.test(chunk) &&
    after.length > 0 &&
    /^[\p{L}\p{N}]/u.test(after);
  const inserted = needsSpace ? `${chunk} ` : chunk;
  const next = text.slice(0, start) + inserted + after;
  return { next, caret: start + inserted.length };
}
